module.exports = __webpack_public_path__ + "d72afbc65f729d7240147754fd270f82.svg";